export default __webpack_public_path__ + "static/media/illustration-features-tab-1.f94c9203.png";